import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_67s18taze0: FaireBrandEntity = {
  token: "b_67s18taze0",
  type: "brand",
  name: "Bianco Dinapoli",
  avatarUrl:
    "https://cdn.faire.com/fastly/9993d07d6b39c76335595864d78a56bb786632a9f4f24e2fbc094d65a226f5fd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/55b8a196ee2592a0b3e3f3340e44052c0b60a2aa42b337a42efa045032b400ec.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9993d07d6b39c76335595864d78a56bb786632a9f4f24e2fbc094d65a226f5fd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/55b8a196ee2592a0b3e3f3340e44052c0b60a2aa42b337a42efa045032b400ec.jpeg",
  location: "los gatos, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.4,
  reviewCount: 66,
  isTopShop: true,
  isInsider: true,
  description:
    "“Whether a tomato or a rumor, consider the source.”\n— CHRIS BIANCO\n\nWho We Are\nBianco DiNapoli Tomatoes are organically-grown and harvested in Northern California. Long summer days and fertile soil produce these very unique & delicious tomatoes. Within hours of harvest, our plum- shaped tomatoes are washed, steam-peeled and hand selected at the cannery. Each can of the original whole-peeled is packed with a touch of sea salt, organic basil then topped in its own juices. We hope you enjoy  them as much as we do!\n\nConnect The Dots\nSeeds, a field and a quiet factory. That's how it begins each winter. By summer, the California tomato harvest begins. \n\nOur mission is to bring you the very best tomatoes that Mother Nature and human ingenuity has to offer. Organically-grown, hand selected, grown and processed in California. You are invited to search our website, meet the people  and businesses that help produce our tomatoes. Ask questions. Give us feedback. Follow us on instagram. Help us Connect the Dots! ",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:24.223Z",
    importedBy: "entity-db-cli",
  },
};
